import { useMemo } from "react";
import { PASS_PROMO_OFFER_END_DATE, PASS_PROMO_STATES } from "../constants/pass";
import { convertUTCtoLocalTime } from "../helpers/dateTimeHelper";
import usePass from "./usePass";

export default function usePassPromo({ enabled = true, productCode, offerEndDate } = {}) {
  const { loading, activePass, passProducts, remainingDays, isAuthenticated } = usePass();

  const hasRunningPass = !!activePass && remainingDays > 0;

  const promoProduct = useMemo(() => {
    if (!passProducts.length) return null;
    if (!productCode) return passProducts[0];

    return passProducts.find((item) => item.productCode === productCode) || passProducts[0];
  }, [passProducts, productCode]);

  const state = useMemo(() => {
    if (loading || !enabled) return null;
    if (hasRunningPass) return PASS_PROMO_STATES.ACTIVE;

    return promoProduct ? PASS_PROMO_STATES.BEFORE_ACTIVATED : null;
  }, [loading, enabled, hasRunningPass, promoProduct]);

  const highlightedDate = useMemo(() => {
    if (hasRunningPass) return convertUTCtoLocalTime(activePass.learningEndDate);

    const configuredDate = offerEndDate || PASS_PROMO_OFFER_END_DATE;
    if (!configuredDate) return null;

    const parsedDate = new Date(configuredDate);

    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }, [hasRunningPass, activePass, offerEndDate]);

  return {
    loading,
    state,
    activePass,
    promoProduct,
    remainingDays,
    highlightedDate,
    isAuthenticated,
  };
}
